import React, { Component } from 'react';

class Month extends Component {
  constructor() {
    super();
    this.state = {
      quantity: 0
    }
  }

  updateQuantity(nextProps) {
    let cartItems = 0
    let monthProducts = nextProps.cart.filter(item => item.month === this.props.id)
    monthProducts.map((item) => {
      return cartItems += item.quantity
    })
    this.setState({quantity: cartItems})
  }

  componentWillReceiveProps(nextProps) {
    this.updateQuantity(nextProps)
  }

  render() {
    return (
      <li className={this.props.id === this.props.theMonth ? "active" : ""}
         onClick={() => this.props.changeMonth(this.props.id)}>
        {this.props.shortTitle}
        {
          this.state.quantity > 0
          ?
          <span className="Months-quantity">{this.state.quantity}</span>
          :
          null
        }
      </li>
    );
  }
}

class Months extends Component {

  render() {
    return (
      <div className="Months container">
        <ul className='Months-list'>
          {
            this.props.months.map((item) => {
              return (
                <Month key={item.id} theMonth={this.props.theMonth} {...item}
                  changeMonth={this.props.changeMonth} cart={this.props.cart} />
              )
            })
          }
        </ul>
      </div>
    );
  }
}

export default Months;



// WEBPACK FOOTER //
// ./src/components/Months.jsx